import React from 'react';
import styled from 'styled-components';
import Image from '../atoms/image';
import { GLOBALS } from '../../utils/globals';
import { useTranslation } from 'react-i18next';
import ScrollTo from '../atoms/ScrollTo';

interface HeroImageProps {
  className?: string;
  target: string;
}

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledImage = styled(Image)`
  margin-bottom: -20px;
  width: 85%;
`;

const HeroImage = ({ target, className }: HeroImageProps) => {
  const { t, i18n } = useTranslation();
  return (
    <StyledContainer className={className}>
      <StyledImage
        ratio={'2621/3356'}
        lazy="lazy"
        imgSrcSmall={
          GLOBALS.theme === 'yellow' ? t('microsite.imageYellow') : t('microsite.imageBlue')
        }
        src={GLOBALS.theme === 'yellow' ? t('microsite.imageYellow') : t('microsite.imageBlue')}
        alt={t('microsite.components.heroimage.label') as string}
      />
      <ScrollTo target={target} />
    </StyledContainer>
  );
};
export default HeroImage;
